import type { IInstallationPoint } from '@model/installationPoint';

export const getFilteredSensorData = (data: Array<IInstallationPoint>, sensorWithAi: boolean) => {
  if (sensorWithAi) {
    return data.filter((data) => data.activeActionItems?.length);
  }

  return data;
};
